import {
  IConfigurationOverrideBaseApiHostname,
  IConfigurations,
  IGenerateBlackboxSuccessPayload,
} from './types';

export enum EConfigurationsActionType {
  GET = 'CONFIGURATIONS_GET',
  GET_SUCCESS = 'CONFIGURATIONS_GET_SUCCESS',
  GENERATE_BLACKBOX = 'GENERATE_BLACKBOX',
  GENERATE_BLACKBOX_SUCCESS = 'GENERATE_BLACKBOX_SUCCESS',
  OVERRIDE_BASE_API_URL = 'OVERRIDE_BASE_API_URL',
}
export interface IGetConfigurationsSuccessAction {
  type: EConfigurationsActionType.GET_SUCCESS;
  payload: IConfigurations;
}

export const getConfigurationsSuccessAction = (payload: IConfigurations) => ({
  type: EConfigurationsActionType.GET_SUCCESS,
  payload,
});

/* ***** *****  Iovation blackbox  ***** ***** */

export const generateBlackbox = () => ({
  type: EConfigurationsActionType.GENERATE_BLACKBOX,
});

// Typing
interface IGenerateBlackboxSuccess {
  type: EConfigurationsActionType.GENERATE_BLACKBOX_SUCCESS;
  payload: IGenerateBlackboxSuccessPayload;
}

export const generateBlackboxSuccess = (
  payload: IGenerateBlackboxSuccessPayload
) => ({
  type: EConfigurationsActionType.GENERATE_BLACKBOX_SUCCESS,
  payload,
});

/* Override app base api url */
interface IOverrideBaseApiHostnameAction {
  type: EConfigurationsActionType.OVERRIDE_BASE_API_URL;
  payload: IConfigurationOverrideBaseApiHostname;
}

export const overrideBaseApiHostname = (
  payload: IConfigurationOverrideBaseApiHostname
) => ({
  type: EConfigurationsActionType.OVERRIDE_BASE_API_URL,
  payload,
});

export type IConfigurationsAction =
  | IGetConfigurationsSuccessAction
  | IGenerateBlackboxSuccess
  | IOverrideBaseApiHostnameAction;
